// @flow
import React from 'react';
import {FormattedMessage} from 'react-intl';

type Props = {
    isLoading: boolean,
    pageNumber: ?number
};

const ResultsAriaLiveStatus = ({isLoading, pageNumber}: Props) => {
    return (
        <div className="sr-only" role="status" aria-live="polite">
            {isLoading ? (
                <FormattedMessage
                    id="searchResultsLoading"
                    defaultMessage="Search results are loading"
                />
            ) : (
                <FormattedMessage
                    id="searchResultsLoadingFinished"
                    defaultMessage="Search results are loaded. Page number {pageNumber}."
                    values={{
                        pageNumber
                    }}
                />
            )}
        </div>
    );
};

export default ResultsAriaLiveStatus;
